module.exports = __webpack_public_path__ + "media/explosion.f1616020.mp3";